import React from 'react';
import { Routes, Route, Navigate, Link } from 'react-router-dom';
import MapPage from './pages/MapPage';
import OnboardingPage from './pages/OnboardingPage';
import ImpressumPage from './pages/ImpressumPage';
import DatenschutzPage from './pages/DatenschutzPage';
import { useAuth } from './contexts/AuthContext';

// React.memo verhindert unnötige Re-Renders der geschützten Routen.
const ProtectedRoute = React.memo(({ element }) => {
    const { isAuthenticated, isLoading } = useAuth();
    if (isLoading) {
        return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', fontSize: '1.2em', color: '#00aaff', backgroundColor: '#121212' }}>Loading Identity...</div>;
    }
    if (!isAuthenticated) {
        return <Navigate to="/start" replace />;
    }
    return element;
});

function App() {
    return (
        <div style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
            <Routes>
                <Route path="/start" element={<OnboardingPage />} />
                <Route path="/" element={<ProtectedRoute element={<MapPage />} />} />
                <Route path="/event/:id" element={<ProtectedRoute element={<MapPage />} />} />
                <Route path="/impressum" element={<ImpressumPage />} />
                <Route path="/datenschutz" element={<DatenschutzPage />} />
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </div>
    );
}
export default App;
